"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6468],{

/***/ 74129:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(67294);
var React__default = _interopDefault(React);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var blocks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS = exports.BLOCKS || (exports.BLOCKS = {}));

});

unwrapExports(blocks);
var blocks_1 = blocks.BLOCKS;

var inlines = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */
var INLINES;
(function (INLINES) {
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
})(INLINES = exports.INLINES || (exports.INLINES = {}));

});

unwrapExports(inlines);
var inlines_1 = inlines.INLINES;

var marks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
})(MARKS || (MARKS = {}));
exports.default = MARKS;

});

unwrapExports(marks);

var schemaConstraints = createCommonjsModule(function (module, exports) {
var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;


var marks_1 = __importDefault(marks);
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */
exports.TOP_LEVEL_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    blocks.BLOCKS.EMBEDDED_RESOURCE,
    blocks.BLOCKS.TABLE,
];
/**
 * Array of all allowed block types inside list items
 */
exports.LIST_ITEM_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    blocks.BLOCKS.EMBEDDED_RESOURCE,
];
exports.TABLE_BLOCKS = [
    blocks.BLOCKS.TABLE,
    blocks.BLOCKS.TABLE_ROW,
    blocks.BLOCKS.TABLE_CELL,
    blocks.BLOCKS.TABLE_HEADER_CELL,
];
/**
 * Array of all void block types
 */
exports.VOID_BLOCKS = [
    blocks.BLOCKS.HR,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    blocks.BLOCKS.EMBEDDED_RESOURCE,
];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */
exports.CONTAINERS = (_a = {},
    _a[blocks.BLOCKS.OL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.UL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
    _a[blocks.BLOCKS.QUOTE] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE] = [blocks.BLOCKS.TABLE_ROW],
    _a[blocks.BLOCKS.TABLE_ROW] = [blocks.BLOCKS.TABLE_CELL, blocks.BLOCKS.TABLE_HEADER_CELL],
    _a[blocks.BLOCKS.TABLE_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE_HEADER_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a);
/**
 * Array of all heading levels
 */
exports.HEADINGS = [
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
];
/**
 * Array of all block types that may contain text and inline nodes.
 */
exports.TEXT_CONTAINERS = __spreadArray([blocks.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */
exports.V1_NODE_TYPES = [
    blocks.BLOCKS.DOCUMENT,
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.LIST_ITEM,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    inlines.INLINES.HYPERLINK,
    inlines.INLINES.ENTRY_HYPERLINK,
    inlines.INLINES.ASSET_HYPERLINK,
    inlines.INLINES.EMBEDDED_ENTRY,
    'text',
];
/**
 * Marks before `superscript` & `subscript` release.
 */
exports.V1_MARKS = [marks_1.default.BOLD, marks_1.default.CODE, marks_1.default.ITALIC, marks_1.default.UNDERLINE];

});

unwrapExports(schemaConstraints);
var schemaConstraints_1 = schemaConstraints.V1_MARKS;
var schemaConstraints_2 = schemaConstraints.V1_NODE_TYPES;
var schemaConstraints_3 = schemaConstraints.TEXT_CONTAINERS;
var schemaConstraints_4 = schemaConstraints.HEADINGS;
var schemaConstraints_5 = schemaConstraints.CONTAINERS;
var schemaConstraints_6 = schemaConstraints.VOID_BLOCKS;
var schemaConstraints_7 = schemaConstraints.TABLE_BLOCKS;
var schemaConstraints_8 = schemaConstraints.LIST_ITEM_BLOCKS;
var schemaConstraints_9 = schemaConstraints.TOP_LEVEL_BLOCKS;

var types = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(types);

var nodeTypes = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(nodeTypes);

var emptyDocument = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
var EMPTY_DOCUMENT = {
    nodeType: blocks.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};
exports.default = EMPTY_DOCUMENT;

});

unwrapExports(emptyDocument);

var helpers = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isText = exports.isBlock = exports.isInline = void 0;


/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines.INLINES, node.nodeType);
}
exports.isInline = isInline;
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks.BLOCKS, node.nodeType);
}
exports.isBlock = isBlock;
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}
exports.isText = isText;

});

unwrapExports(helpers);
var helpers_1 = helpers.isText;
var helpers_2 = helpers.isBlock;
var helpers_3 = helpers.isInline;

var dist = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;

Object.defineProperty(exports, "BLOCKS", { enumerable: true, get: function () { return blocks.BLOCKS; } });

Object.defineProperty(exports, "INLINES", { enumerable: true, get: function () { return inlines.INLINES; } });

Object.defineProperty(exports, "MARKS", { enumerable: true, get: function () { return __importDefault(marks).default; } });
__exportStar(schemaConstraints, exports);
__exportStar(types, exports);
__exportStar(nodeTypes, exports);

Object.defineProperty(exports, "EMPTY_DOCUMENT", { enumerable: true, get: function () { return __importDefault(emptyDocument).default; } });
var helpers$1 = __importStar(helpers);
exports.helpers = helpers$1;

});

unwrapExports(dist);
var dist_1 = dist.helpers;
var dist_2 = dist.EMPTY_DOCUMENT;
var dist_3 = dist.MARKS;
var dist_4 = dist.INLINES;
var dist_5 = dist.BLOCKS;

function appendKeyToValidElement(element, key) {
    if (React.isValidElement(element) && element.key === null) {
        return React.cloneElement(element, { key: key });
    }
    return element;
}

function nodeListToReactComponents(nodes, options) {
    return nodes.map(function (node, index) {
        return appendKeyToValidElement(nodeToReactComponent(node, options), index);
    });
}
function nodeToReactComponent(node, options) {
    var renderNode = options.renderNode, renderMark = options.renderMark, renderText = options.renderText, preserveWhitespace = options.preserveWhitespace;
    if (dist_1.isText(node)) {
        var nodeValue = renderText ? renderText(node.value) : node.value;
        if (preserveWhitespace) {
            // Preserve multiple spaces.
            nodeValue = nodeValue.replace(/ {2,}/g, function (match) { return '&nbsp;'.repeat(match.length); });
            // Preserve line breaks.
            var lines_1 = nodeValue.split('\n');
            var jsxLines_1 = [];
            lines_1.forEach(function (line, index) {
                jsxLines_1.push(line);
                if (index !== lines_1.length - 1) {
                    jsxLines_1.push(React__default.createElement("br", null));
                }
            });
            nodeValue = jsxLines_1;
        }
        return node.marks.reduce(function (value, mark) {
            if (!renderMark[mark.type]) {
                return value;
            }
            return renderMark[mark.type](value);
        }, nodeValue);
    }
    else {
        var children = nodeListToReactComponents(node.content, options);
        if (!node.nodeType || !renderNode[node.nodeType]) {
            return React__default.createElement(React__default.Fragment, null, children);
        }
        return renderNode[node.nodeType](node, children);
    }
}

var _a, _b;
var defaultNodeRenderers = (_a = {},
    _a[dist_5.DOCUMENT] = function (node, children) { return children; },
    _a[dist_5.PARAGRAPH] = function (node, children) { return React__default.createElement("p", null, children); },
    _a[dist_5.HEADING_1] = function (node, children) { return React__default.createElement("h1", null, children); },
    _a[dist_5.HEADING_2] = function (node, children) { return React__default.createElement("h2", null, children); },
    _a[dist_5.HEADING_3] = function (node, children) { return React__default.createElement("h3", null, children); },
    _a[dist_5.HEADING_4] = function (node, children) { return React__default.createElement("h4", null, children); },
    _a[dist_5.HEADING_5] = function (node, children) { return React__default.createElement("h5", null, children); },
    _a[dist_5.HEADING_6] = function (node, children) { return React__default.createElement("h6", null, children); },
    _a[dist_5.EMBEDDED_ENTRY] = function (node, children) { return React__default.createElement("div", null, children); },
    _a[dist_5.EMBEDDED_RESOURCE] = function (node, children) { return React__default.createElement("div", null, children); },
    _a[dist_5.UL_LIST] = function (node, children) { return React__default.createElement("ul", null, children); },
    _a[dist_5.OL_LIST] = function (node, children) { return React__default.createElement("ol", null, children); },
    _a[dist_5.LIST_ITEM] = function (node, children) { return React__default.createElement("li", null, children); },
    _a[dist_5.QUOTE] = function (node, children) { return React__default.createElement("blockquote", null, children); },
    _a[dist_5.HR] = function () { return React__default.createElement("hr", null); },
    _a[dist_5.TABLE] = function (node, children) { return (React__default.createElement("table", null,
        React__default.createElement("tbody", null, children))); },
    _a[dist_5.TABLE_ROW] = function (node, children) { return React__default.createElement("tr", null, children); },
    _a[dist_5.TABLE_HEADER_CELL] = function (node, children) { return React__default.createElement("th", null, children); },
    _a[dist_5.TABLE_CELL] = function (node, children) { return React__default.createElement("td", null, children); },
    _a[dist_4.ASSET_HYPERLINK] = function (node) { return defaultInline(dist_4.ASSET_HYPERLINK, node); },
    _a[dist_4.ENTRY_HYPERLINK] = function (node) { return defaultInline(dist_4.ENTRY_HYPERLINK, node); },
    _a[dist_4.RESOURCE_HYPERLINK] = function (node) {
        return defaultInlineResource(dist_4.RESOURCE_HYPERLINK, node);
    },
    _a[dist_4.EMBEDDED_ENTRY] = function (node) { return defaultInline(dist_4.EMBEDDED_ENTRY, node); },
    _a[dist_4.EMBEDDED_RESOURCE] = function (node, children) {
        return defaultInlineResource(dist_4.EMBEDDED_RESOURCE, node);
    },
    _a[dist_4.HYPERLINK] = function (node, children) { return React__default.createElement("a", { href: node.data.uri }, children); },
    _a);
var defaultMarkRenderers = (_b = {},
    _b[dist_3.BOLD] = function (text) { return React__default.createElement("b", null, text); },
    _b[dist_3.ITALIC] = function (text) { return React__default.createElement("i", null, text); },
    _b[dist_3.UNDERLINE] = function (text) { return React__default.createElement("u", null, text); },
    _b[dist_3.CODE] = function (text) { return React__default.createElement("code", null, text); },
    _b[dist_3.SUPERSCRIPT] = function (text) { return React__default.createElement("sup", null, text); },
    _b[dist_3.SUBSCRIPT] = function (text) { return React__default.createElement("sub", null, text); },
    _b);
function defaultInline(type, node) {
    return (React__default.createElement("span", { key: node.data.target.sys.id },
        "type: ",
        node.nodeType,
        " id: ",
        node.data.target.sys.id));
}
function defaultInlineResource(type, node) {
    return (React__default.createElement("span", { key: node.data.target.sys.urn },
        "type: ",
        node.nodeType,
        " urn: ",
        node.data.target.sys.urn));
}
/**
 * Serialize a Contentful Rich Text `document` to React tree
 */
function documentToReactComponents(richTextDocument, options) {
    if (options === void 0) { options = {}; }
    if (!richTextDocument) {
        return null;
    }
    return nodeToReactComponent(richTextDocument, {
        renderNode: __assign(__assign({}, defaultNodeRenderers), options.renderNode),
        renderMark: __assign(__assign({}, defaultMarkRenderers), options.renderMark),
        renderText: options.renderText,
        preserveWhitespace: options.preserveWhitespace,
    });
}

exports.h = documentToReactComponents;
//# sourceMappingURL=rich-text-react-renderer.es5.js.map


/***/ }),

/***/ 20549:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS = exports.BLOCKS || (exports.BLOCKS = {}));
//# sourceMappingURL=blocks.js.map

/***/ }),

/***/ 51928:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var blocks_1 = __webpack_require__(20549);
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
var EMPTY_DOCUMENT = {
    nodeType: blocks_1.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks_1.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};
exports["default"] = EMPTY_DOCUMENT;
//# sourceMappingURL=emptyDocument.js.map

/***/ }),

/***/ 86061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isText = exports.isBlock = exports.isInline = void 0;
var blocks_1 = __webpack_require__(20549);
var inlines_1 = __webpack_require__(7845);
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines_1.INLINES, node.nodeType);
}
exports.isInline = isInline;
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks_1.BLOCKS, node.nodeType);
}
exports.isBlock = isBlock;
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}
exports.isText = isText;
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 86437:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;
var blocks_1 = __webpack_require__(20549);
Object.defineProperty(exports, "BLOCKS", ({ enumerable: true, get: function () { return blocks_1.BLOCKS; } }));
var inlines_1 = __webpack_require__(7845);
Object.defineProperty(exports, "INLINES", ({ enumerable: true, get: function () { return inlines_1.INLINES; } }));
var marks_1 = __webpack_require__(31376);
Object.defineProperty(exports, "MARKS", ({ enumerable: true, get: function () { return __importDefault(marks_1).default; } }));
__exportStar(__webpack_require__(97951), exports);
__exportStar(__webpack_require__(80167), exports);
__exportStar(__webpack_require__(11911), exports);
var emptyDocument_1 = __webpack_require__(51928);
Object.defineProperty(exports, "EMPTY_DOCUMENT", ({ enumerable: true, get: function () { return __importDefault(emptyDocument_1).default; } }));
var helpers = __importStar(__webpack_require__(86061));
exports.helpers = helpers;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7845:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */
var INLINES;
(function (INLINES) {
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
})(INLINES = exports.INLINES || (exports.INLINES = {}));
//# sourceMappingURL=inlines.js.map

/***/ }),

/***/ 31376:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
})(MARKS || (MARKS = {}));
exports["default"] = MARKS;
//# sourceMappingURL=marks.js.map

/***/ }),

/***/ 11911:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=nodeTypes.js.map

/***/ }),

/***/ 97951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;
var blocks_1 = __webpack_require__(20549);
var inlines_1 = __webpack_require__(7845);
var marks_1 = __importDefault(__webpack_require__(31376));
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */
exports.TOP_LEVEL_BLOCKS = [
    blocks_1.BLOCKS.PARAGRAPH,
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
    blocks_1.BLOCKS.OL_LIST,
    blocks_1.BLOCKS.UL_LIST,
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.QUOTE,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
    blocks_1.BLOCKS.EMBEDDED_RESOURCE,
    blocks_1.BLOCKS.TABLE,
];
/**
 * Array of all allowed block types inside list items
 */
exports.LIST_ITEM_BLOCKS = [
    blocks_1.BLOCKS.PARAGRAPH,
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
    blocks_1.BLOCKS.OL_LIST,
    blocks_1.BLOCKS.UL_LIST,
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.QUOTE,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
    blocks_1.BLOCKS.EMBEDDED_RESOURCE,
];
exports.TABLE_BLOCKS = [
    blocks_1.BLOCKS.TABLE,
    blocks_1.BLOCKS.TABLE_ROW,
    blocks_1.BLOCKS.TABLE_CELL,
    blocks_1.BLOCKS.TABLE_HEADER_CELL,
];
/**
 * Array of all void block types
 */
exports.VOID_BLOCKS = [
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
    blocks_1.BLOCKS.EMBEDDED_RESOURCE,
];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */
exports.CONTAINERS = (_a = {},
    _a[blocks_1.BLOCKS.OL_LIST] = [blocks_1.BLOCKS.LIST_ITEM],
    _a[blocks_1.BLOCKS.UL_LIST] = [blocks_1.BLOCKS.LIST_ITEM],
    _a[blocks_1.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
    _a[blocks_1.BLOCKS.QUOTE] = [blocks_1.BLOCKS.PARAGRAPH],
    _a[blocks_1.BLOCKS.TABLE] = [blocks_1.BLOCKS.TABLE_ROW],
    _a[blocks_1.BLOCKS.TABLE_ROW] = [blocks_1.BLOCKS.TABLE_CELL, blocks_1.BLOCKS.TABLE_HEADER_CELL],
    _a[blocks_1.BLOCKS.TABLE_CELL] = [blocks_1.BLOCKS.PARAGRAPH],
    _a[blocks_1.BLOCKS.TABLE_HEADER_CELL] = [blocks_1.BLOCKS.PARAGRAPH],
    _a);
/**
 * Array of all heading levels
 */
exports.HEADINGS = [
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
];
/**
 * Array of all block types that may contain text and inline nodes.
 */
exports.TEXT_CONTAINERS = __spreadArray([blocks_1.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */
exports.V1_NODE_TYPES = [
    blocks_1.BLOCKS.DOCUMENT,
    blocks_1.BLOCKS.PARAGRAPH,
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
    blocks_1.BLOCKS.OL_LIST,
    blocks_1.BLOCKS.UL_LIST,
    blocks_1.BLOCKS.LIST_ITEM,
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.QUOTE,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
    inlines_1.INLINES.HYPERLINK,
    inlines_1.INLINES.ENTRY_HYPERLINK,
    inlines_1.INLINES.ASSET_HYPERLINK,
    inlines_1.INLINES.EMBEDDED_ENTRY,
    'text',
];
/**
 * Marks before `superscript` & `subscript` release.
 */
exports.V1_MARKS = [marks_1.default.BOLD, marks_1.default.CODE, marks_1.default.ITALIC, marks_1.default.UNDERLINE];
//# sourceMappingURL=schemaConstraints.js.map

/***/ }),

/***/ 80167:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 3074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports AlertRow, AlertLink */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42866);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74229);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25522);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2349);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7820);










const AlertRow = (param)=>/*#__PURE__*/ {
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_6__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_7__/* .spacingProps */ .tF
    } , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        sx: {
            fontSize: "m",
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(sx)
        },
        spacing: {
            my: 0,
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(spacing)
        },
        ...props,
        children: children
    });
};
AlertRow.propTypes = {
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_6__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_7__/* .spacingPropTypes */ .Xj,
    isLast: prop_types__WEBPACK_IMPORTED_MODULE_9__.bool,
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes
};
const AlertLink = (param)=>/*#__PURE__*/ {
    let { href , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        href: href,
        className: "alert__link",
        ...props,
        children: children
    });
};
AlertLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const Alert = (param)=>{
    let { title ="" , status ="success" , className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("alert", "alert--".concat(status), className),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                Tag: "h3",
                className: "alert__title",
                children: title
            }),
            children
        ]
    });
};
Alert.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_9__.node,
    status: (0,prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOf)([
        "default",
        "success",
        "error",
        "warning"
    ]),
    className: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node.isRequired
};
Alert.Row = AlertRow;
Alert.Link = AlertLink;
/* harmony default export */ __webpack_exports__["ZP"] = (Alert);


/***/ }),

/***/ 182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18981);








const Td = (param)=>{
    let { className ="" , align , isBorderNone =false , isActive =false , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .tF
    } , verticalAlign , children , ...props } = param;
    const borderProp = isBorderNone ? {
        border: {
            width: 0
        }
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("table__td", isActive && "table-active", align && "table__td--".concat(align), verticalAlign && "table__td-vertical-align--".concat(verticalAlign), ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            ...borderProp
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(utility))), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: children
    });
};
Td.propTypes = {
    isActive: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    isBorderNone: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    align: _props_sx__WEBPACK_IMPORTED_MODULE_3__/* .textAlignPropTypes */ .g4,
    className: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityPropTypes */ .pQ,
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingPropTypes */ .Xj,
    children: prop_types__WEBPACK_IMPORTED_MODULE_7__.node,
    verticalAlign: (0,prop_types__WEBPACK_IMPORTED_MODULE_7__.oneOf)([
        "baseline",
        "top",
        "middle",
        "sub",
        "bottom",
        "text-top"
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = (Td);


/***/ }),

/***/ 455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7820);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18981);







const Tr = (param)=>{
    let { className ="" , isBorderNone =false , isActive =false , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_4__/* .utilityProps */ .Gm
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .tF
    } , ...props } = param;
    const borderProp = isBorderNone ? {
        border: {
            width: 0
        }
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("table__tr", isActive && "table-active", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_4__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_5__/* .deepMergeProps */ .p)({
            ...borderProp
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(utility))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: children
    });
};
Tr.propTypes = {
    isActive: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isBorderNone: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_4__/* .utilityPropTypes */ .pQ,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingPropTypes */ .Xj
};
/* harmony default export */ __webpack_exports__["Z"] = (Tr);


/***/ }),

/***/ 72379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Table_Table; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Table.js





const Table = (param)=>{
    let { className ="" , isStriped =false , isBottomBorderedStriped =false , isBottomBordered =false , isBordered =false , isBorderedWrapper =false , children , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
        className: (0,classes/* classes */.S)("table", isBottomBordered && "table-bottom-bordered", isBottomBorderedStriped && "table-bottom-bordered-striped", isBordered && "table-bordered", isBorderedWrapper && "table-bordered-wrapper", isStriped && "table-striped", ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
Table.propTypes = {
    className: prop_types.string,
    isBottomBordered: prop_types.bool,
    isBordered: prop_types.bool,
    isBorderedWrapper: prop_types.bool,
    isStriped: prop_types.bool,
    isBottomBorderedStriped: prop_types.bool,
    children: prop_types.node.isRequired,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Table_Table = (Table);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Table/index.js



/***/ }),

/***/ 6292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ WistiaVideo_WistiaVideo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/WistiaVideo/WistiaVideo.js



const WistiaVideo = (param)=>{
    let { children  } = param;
    (0,react.useEffect)(()=>{
        if (!document.getElementById("wistia_script")) {
            const wistiaScript = document.createElement("script");
            wistiaScript.id = "wistia_script";
            wistiaScript.type = "text/javascript";
            wistiaScript.src = "https://fast.wistia.com/assets/external/E-v1.js";
            wistiaScript.async = true;
            document.body.appendChild(wistiaScript);
            /* eslint no-underscore-dangle: ["error", { "allow": ["_wq"] }] */ window._wq = window._wq || [];
            // eslint-disable-next-line no-undef
            _wq.push({
                id: "_all",
                onReady (video) {
                    video.bind("play", ()=>{
                        // eslint-disable-next-line no-undef
                        const allVideos = Wistia.api.all();
                        allVideos.forEach((v)=>{
                            if (v.uuid !== video.uuid) {
                                v.pause();
                            }
                        });
                    });
                }
            });
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "wistia-video-container",
        children: children
    });
};
WistiaVideo.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var WistiaVideo_WistiaVideo = (WistiaVideo);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/WistiaVideo/index.js



/***/ }),

/***/ 34124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ richTextTypes_default; }
});

// UNUSED EXPORTS: h1

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(86437);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Alert/index.js
var Alert = __webpack_require__(3074);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PostElement/index.js + 4 modules
var PostElement = __webpack_require__(22857);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/index.js + 1 modules
var Table = __webpack_require__(72379);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Tr.js
var Tr = __webpack_require__(455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Td.js
var Td = __webpack_require__(182);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/richTextTypes/default/utils.js + 1 modules
var utils = __webpack_require__(69482);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/ui/WistiaVideoEmbed.js + 1 modules
var WistiaVideoEmbed = __webpack_require__(10917);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/YouTubeVideo/YouTubeVideo.js




const YouTubeVideo = (param)=>{
    let { className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("video-responsive", className),
        children: children
    });
};
YouTubeVideo.propTypes = {
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var YouTubeVideo_YouTubeVideo = (YouTubeVideo);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/YouTubeVideo/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/YouTubeVideo/Embed.js



const YouTubeEmbed = (param)=>{
    let { id , title ="" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
        className: "video-responsive__iframe",
        style: {
            width: "100%"
        },
        height: "315",
        src: "https://www.youtube.com/embed/".concat(id),
        title: title,
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true,
        ...props
    });
};
YouTubeEmbed.propTypes = {
    id: prop_types.string.isRequired,
    title: prop_types.string
};
/* harmony default export */ var Embed = (YouTubeEmbed);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/ui/YouTubeVideoEmbed.js






const YouTubeVideoEmbed = (param)=>{
    let { title ="" , caption ="" , url  } = param;
    const youtubeObject = url.match(/(?:(?:v|vi|be|videos|embed)\/(?!videoseries)|(?:v|ci)=)([\w-]{11})/i);
    return youtubeObject ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementVideo */.Jh, {
        caption: caption,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTubeVideo_YouTubeVideo, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Embed, {
                id: youtubeObject[1],
                title: title
            })
        })
    }) : null;
};
YouTubeVideoEmbed.propTypes = {
    title: prop_types.string,
    caption: prop_types.string,
    url: prop_types.string.isRequired
};
/* harmony default export */ var ui_YouTubeVideoEmbed = (YouTubeVideoEmbed);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/getContentProps.js
var getContentProps = __webpack_require__(76638);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/ui/PostEntryLink.js






const PostEntryLink = (param)=>{
    let { contentId , slug ="" , children , ...props } = param;
    const contentProps = (0,getContentProps/* default */.Z)(contentId);
    const isCustom = contentProps === false;
    if (isCustom) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: slug,
            target: "_blank",
            children: children
        });
    }
    const isExternal = contentProps && contentProps.type === "external";
    const Tag = (param)=>{
        let { ...tagProps } = param;
        return isExternal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            ...tagProps
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
            ...tagProps
        });
    };
    const href = isExternal ? slug : "".concat(contentProps.alias, "/").concat(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        href: href,
        ...props,
        target: isExternal ? "_blank" : "_self",
        children: children
    });
};
PostEntryLink.propTypes = {
    contentId: prop_types.string.isRequired,
    slug: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var ui_PostEntryLink = (PostEntryLink);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/ui/RichTextLink.js
var RichTextLink = __webpack_require__(10257);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/richTextTypes/default/index.js
/* eslint-disable react/no-array-index-key */ 













const h1 = (/* unused pure expression or super */ null && ([]));
const richTextTypes = {
    renderNode: {
        [dist.BLOCKS.HEADING_1]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementTitleH1 */.HS, {
                children: children
            }),
        [dist.BLOCKS.HEADING_2]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementTitleH2 */.LA, {
                id: (0,utils/* generateHeadingId */.A)(children),
                children: children
            }),
        [dist.BLOCKS.HEADING_3]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementTitleH3 */.Q2, {
                children: children
            }),
        [dist.BLOCKS.HEADING_4]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementTitleH4 */.p_, {
                children: children
            }),
        [dist.BLOCKS.HEADING_5]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementTitleH5 */.Dy, {
                children: children
            }),
        [dist.BLOCKS.HEADING_6]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementTitleH6 */.UE, {
                children: children
            }),
        [dist.BLOCKS.PARAGRAPH]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                children: children
            }),
        [dist.BLOCKS.QUOTE]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementBlockQuote */.gO, {
                children: children
            }),
        [dist.BLOCKS.UL_LIST]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementUl */.Nj, {
                children: children
            }),
        [dist.BLOCKS.OL_LIST]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementOl */.vb, {
                children: children
            }),
        [dist.INLINES.HYPERLINK]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextLink/* default */.Z, {
                ...node,
                children: children
            }),
        [dist.INLINES.ENTRY_HYPERLINK]: (node, children)=>{
            const { data  } = node;
            const { id  } = data.target.sys.contentType.sys;
            const { slug  } = data.target.fields || "";
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_PostEntryLink, {
                contentId: id,
                slug: slug,
                children: children
            });
        },
        [dist.BLOCKS.LIST_ITEM]: (node)=>{
            const UnTaggedChildren = (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(node, {
                renderNode: {
                    [dist.BLOCKS.PARAGRAPH]: (nodeParagraph, childrenParagraph)=>childrenParagraph,
                    [dist.BLOCKS.UL_LIST]: (nodeUl, childrenUl)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementUl */.Nj, {
                            children: childrenUl
                        }),
                    [dist.BLOCKS.OL_LIST]: (nodeOl, childrenOl)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementOl */.vb, {
                            children: childrenOl
                        }),
                    [dist.BLOCKS.LIST_ITEM]: (nodeLi, childrenLi)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                            children: childrenLi
                        }),
                    [dist.INLINES.HYPERLINK]: (nodeLink, childrenLink)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextLink/* default */.Z, {
                            ...nodeLink,
                            children: childrenLink
                        })
                },
                renderText: (children)=>children.replace(/\u2028/g, "").split("\n").flatMap((text, i)=>[
                            i > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, "br_".concat(i)),
                            text
                        ])
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: UnTaggedChildren
            });
        },
        [dist.BLOCKS.HR]: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementLine */.ju, {}),
        [dist.BLOCKS.EMBEDDED_ASSET]: (node)=>{
            const { data  } = node;
            if (data.target.fields && data.target.fields.file.contentType === "text/html") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.ZP, {
                    status: "error",
                    children: "EMBEDDED_ASSET_BLOCK"
                });
            }
            if (data.target.fields && data.target.fields.file) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementImage */.LV, {
                    src: data.target.fields.file.url,
                    alt: data.target.fields.title,
                    caption: data.target.fields.description
                });
            }
            return null;
        },
        [dist.BLOCKS.EMBEDDED_ENTRY]: (node)=>{
            const { data  } = node;
            const { fields  } = data.target;
            if (fields.videoUrl) {
                const { title , description , videoUrl  } = fields;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideoEmbed/* default */.Z, {
                            url: videoUrl,
                            caption: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_YouTubeVideoEmbed, {
                            url: videoUrl,
                            title: title,
                            caption: description
                        })
                    ]
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.ZP, {
                status: "error",
                children: "EMBEDDED_ENTRY_BLOCK"
            });
        },
        [dist.BLOCKS.TABLE]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                isBordered: true,
                children: children
            }),
        [dist.BLOCKS.TABLE_ROW]: (node, children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Tr/* default */.Z, {
                children: children
            }),
        [dist.BLOCKS.TABLE_HEADER_CELL]: (node)=>{
            const UnTaggedChildren = (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(node, {
                renderNode: {
                    [dist.BLOCKS.PARAGRAPH]: (_, childrenParagraph)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            spacing: {
                                my: 0
                            },
                            children: childrenParagraph
                        })
                }
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                isActive: true,
                spacing: {
                    px: 2
                },
                children: UnTaggedChildren
            });
        },
        [dist.BLOCKS.TABLE_CELL]: (node)=>{
            const UnTaggedChildren = (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(node, {
                renderNode: {
                    [dist.BLOCKS.PARAGRAPH]: (_, childrenParagraph)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            spacing: {
                                my: 0
                            },
                            children: childrenParagraph
                        })
                }
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
                spacing: {
                    px: 2
                },
                children: UnTaggedChildren
            });
        }
    }
};
/* harmony default export */ var richTextTypes_default = (richTextTypes);


/***/ }),

/***/ 69482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ generateHeadingId; },
  "U": function() { return /* binding */ sidebarNavigation; }
});

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/fn/to-base-64.js
function toBase64(str) {
    if (false) {}
    return window.btoa(str);
}

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/richTextTypes/default/utils.js

const generateHeadingId = (children)=>{
    return toBase64(encodeURI(children.toString().trim())).replace(/=/g, "");
};
const sidebarNavigation = (body)=>body.content.filter((node)=>node.nodeType === "heading-2").map((item)=>item.content[0].value);


/***/ }),

/***/ 10917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ui_WistiaVideoEmbed; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/WistiaVideo/Embed.js




const WistiaVideoEmbed = (param)=>{
    let { id , className =""  } = param;
    (0,react.useLayoutEffect)(()=>{
        const script = document.createElement("script");
        script.src = "https://fast.wistia.com/embed/medias/".concat(id, ".jsonp");
        script.async = true;
        document.body.appendChild(script);
        return ()=>{
            script.remove();
        };
    }, [
        id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("wistia_embed", "wistia_async_".concat(id), "wistia-block-detail__embed", "videoFoam=true", className)
    });
};
WistiaVideoEmbed.propTypes = {
    id: prop_types.string.isRequired,
    className: prop_types.string
};
/* harmony default export */ var Embed = (WistiaVideoEmbed);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/WistiaVideo/index.js + 1 modules
var WistiaVideo = __webpack_require__(6292);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PostElement/index.js + 4 modules
var PostElement = __webpack_require__(22857);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/ui/WistiaVideoEmbed.js






const WistiaVideoEmbed_Embed = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,jsx_runtime.jsx)(WistiaVideo/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Embed, {
            ...props
        })
    });
};
const WistiaVideoEmbed_WistiaVideoEmbed = (param)=>{
    let { caption ="" , url  } = param;
    const wistiaObject = url.match(/https?:\/\/[^.]+\.(wistia\.com|wi\.st)\/(medias|embed)\/.*/) && url.match(/(?:(?:medias|iframe)\/|wvideo=)([\w-]+)/);
    const VideoBlock = (0,react.useCallback)(()=>{
        return caption ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementVideo */.Jh, {
            caption: caption,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideoEmbed_Embed, {
                id: wistiaObject[1]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideoEmbed_Embed, {
            id: wistiaObject[1]
        });
    }, [
        caption,
        wistiaObject
    ]);
    return wistiaObject ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoBlock, {}) : null;
};
WistiaVideoEmbed_WistiaVideoEmbed.propTypes = {
    caption: prop_types.string,
    url: prop_types.string.isRequired
};
/* harmony default export */ var ui_WistiaVideoEmbed = (WistiaVideoEmbed_WistiaVideoEmbed);


/***/ }),

/***/ 50420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ sanitize; }
/* harmony export */ });
/* harmony import */ var _insightfulscience_shared_utils_fn_pipe__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75833);

const decycle = function(obj) {
    let stack = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (!obj || typeof obj !== "object") return obj;
    if (stack.includes(obj)) return null;
    const s = stack.concat([
        obj
    ]);
    return Array.isArray(obj) ? obj.map((x)=>decycle(x, s)) : Object.fromEntries(Object.entries(obj).map((param)=>{
        let [k, v] = param;
        return [
            k,
            decycle(v, s)
        ];
    }));
};
const nullTypes = (type)=>(object)=>{
        if (object === null) return object;
        const newObject = Array.isArray(object) ? [
            ...object
        ] : {
            ...object
        };
        if ([
            "series",
            "guides"
        ].includes(type)) {
            if ("recommendedVideos" in newObject) {
                newObject.recommendedVideos = newObject.recommendedVideos.map((rv)=>({
                        ...rv,
                        fields: {
                            ...rv.fields,
                            recommendedVideos: null
                        }
                    }));
            }
        }
        return newObject;
    };
const sanitize = function(object) {
    let type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return (0,_insightfulscience_shared_utils_fn_pipe__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(object, nullTypes(type), decycle);
};


/***/ }),

/***/ 55161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ createAndRaise; }
/* harmony export */ });
/**
 * Creates a function that throws Error created with errorFactory
 *
 * @type {<A extends any[], E extends Error>(errorFactory: (...args: A) => E) => (...args: A) => never}
 */ const createAndRaise = (errorFactory)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        throw errorFactory(...args);
    };


/***/ })

}]);